class HCLDX {
    static baseURL() {
        let r = this.get_REACT_APP_HCL_DX_BASE_URL();
        let u = '';
        if (r !== undefined) {
            u = r;
            if (window.avnet !== undefined &&
                window.avnet.siteId !== undefined) {
                u += window.avnet.siteId;
            }
        }
        return u;
    }

    static baseURLOfHCLDX() {
        return this.get_REACT_APP_HCL_DX_DOMAIN();
    }

    static get_REACT_APP_HCL_DX_BASE_URL() {
        return process.env.REACT_APP_HCL_DX_BASE_URL;
    }

    static get_REACT_APP_HCL_DX_DOMAIN() {
        return process.env.REACT_APP_HCL_DX_DOMAIN;
    }
}

export default HCLDX;